import { useSlideContext } from "./SlideContext";

/**
 * The eyebrow as a filled tab flush to the card's own top-left corner.
 *
 * It escapes the slide's padding with negative margins rather than the slide
 * dropping its padding, so adopting it changes nothing else on the slide. Only
 * the bottom-right corner is rounded; the other three are the card's edge.
 *
 * Lives on its own so the statement band (SlideStatement) and slides still on
 * the old header (SlideHeader, with `tab`) render one identical tab rather
 * than two copies that drift.
 *
 * It assumes the slide root carries the deck's standard md:px-24 md:pt-16
 * padding. A slide with different insets needs its own offsets, not this.
 */
export function SlideEyebrowTab({
  eyebrow,
  unnumbered,
}: {
  eyebrow: string;
  /** Suppress the auto "NN _ " prefix — the lettered appendix slides. */
  unnumbered?: boolean;
}) {
  const ctx = useSlideContext();
  const prefix =
    !unnumbered && ctx != null
      ? `${(ctx.index + 1).toString().padStart(2, "0")} _ `
      : "";

  return (
    <div className="-ml-6 -mt-8 self-start rounded-br-2xl bg-blue-600 px-6 py-2.5 md:-ml-24 md:-mt-16 md:px-8 md:py-2.5">
      <p className="text-xs font-semibold uppercase tracking-[0.2em] text-white md:text-sm md:tracking-[0.25em]">
        {prefix}
        {eyebrow}
      </p>
    </div>
  );
}
